module.exports = function(gantt) {
gantt.skins.terrace = {
	config:{
		grid_width:360,
		row_height: 35,
		scale_height: 35,
		link_line_width:2,
		link_arrow_size:6,
		lightbox_additional_height:75
	},
	_second_column_width:90,
	_third_column_width:70		
};

};


//////////////////
// WEBPACK FOOTER
// ./sources/css/skins/terrace.js
// module id = 87
// module chunks = 0